import { Outlet } from "react-router-dom";

export default function MarketQuotesLayout() {
    return <Outlet />;
}
